module.exports = __webpack_public_path__ + "static/media/pool_card.eb808014.svg";